import { CF_PREFIX } from '@/constants/initiative'

const isFieldACustomField = field => new RegExp('^' + CF_PREFIX + '[0-9]*$').test(field)

export default isFieldACustomField
